import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { RollupContentComponent } from '@fi-shared/rollup/rollup-content.component';

export interface IVersionListColumn {
    Name: string;
    Title: string;
    Content?: (version: any) => string;
}

@Component({
    selector: 'fi-versions-list',
    templateUrl: './versions-list.component.html',
    styleUrls: ['./versions-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class VersionsListComponent implements OnInit, OnChanges {
    @Input() versionsList: Array<any>;
    @Input() versionsFields: Array<IVersionListColumn>;
    @Input() currentVersion: any;
    @Input() startAsVisible: boolean = true;

    @ViewChild(RollupContentComponent, { static: false }) rollupContent: RollupContentComponent;

    @Output('afterOpen') afterOpenEmitter = new EventEmitter<RollupContentComponent>();
    @Output('versionClick') versionClickEmitter = new EventEmitter();

    sortedItems = [];

    constructor() {}

    toggleContent() {
        this.rollupContent.toggleContent().then(() => {
            if (this.rollupContent.opened) {
                this.afterOpenEmitter.emit(this.rollupContent);
            }
        });
    }

    GetVersionFieldContent(version, field) {
        if (field.Content) {
            if (typeof field.Content == 'function') {
                return field.Content(version);
            }
            return field.Content;
        }
        return version[field.Name];
    }

    Sort = {
        Field: null,
        Direction: false,
    };

    ngOnInit() {
        this.sortItems();
    }

    HeaderItemClick(Field) {
        if (this.Sort.Field === Field) {
            this.Sort.Direction = !this.Sort.Direction;
        } else {
            this.Sort.Field = Field;
            this.Sort.Direction = true;
        }
        this.sortItems();
    }

    sortItems() {
        const self = this;
        if (!this.Sort.Field) {
            this.Sort.Field = this.versionsFields[0];
        }

        function comparatorDesc(a, b) {
            if (a[self.Sort.Field.Name] > b[self.Sort.Field.Name]) {
                return 1;
            } else if (a[self.Sort.Field.Name] == b[self.Sort.Field.Name]) {
                return 0;
            } else {
                return -1;
            }
        }

        function comparatorAsc(a, b) {
            if (a[self.Sort.Field.Name] < b[self.Sort.Field.Name]) {
                return 1;
            } else if (a[self.Sort.Field.Name] == b[self.Sort.Field.Name]) {
                return 0;
            } else {
                return -1;
            }
        }

        const comparator = this.Sort.Direction ? comparatorAsc : comparatorDesc;

        this.sortedItems = this.versionsList.filter((v) => !v.IsDraft).sort(comparator);
    }

    _versionClick(version) {
        this.versionClickEmitter.emit(version);
    }

    ngOnChanges(changes: SimpleChanges) {
        this.sortItems();
    }
}
